import { clsx } from 'clsx'
import { NavLink } from 'react-router'
import { StampIcon } from '@/components/ui/stamp-icon'
import { ICON_MAP, NAV_ITEMS } from '@/lib/nav-items'

interface SidebarProps {
  collapsed?: boolean
}

export function Sidebar({ collapsed = false }: SidebarProps): React.JSX.Element {
  return (
    <aside
      className={clsx(
        'flex h-full flex-col border-r border-surface-3 bg-surface-0 transition-all duration-200',
        collapsed ? 'w-16' : 'w-64',
      )}
    >
      <div className="flex h-16 items-center border-b border-surface-3 px-4">
        <NavLink to="/" className="flex items-center gap-2">
          <StampIcon size={32} variant="solid" />
          {!collapsed && <span className="text-lg font-semibold text-text-primary">One-Email</span>}
        </NavLink>
      </div>

      <nav className="flex-1 space-y-1 p-3">
        {NAV_ITEMS.map((item) => {
          const Icon = ICON_MAP[item.icon]
          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-brand-50 text-brand-700'
                    : 'text-text-secondary hover:bg-surface-1 hover:text-text-primary',
                  collapsed && 'justify-center',
                )
              }
            >
              <Icon className="h-5 w-5 shrink-0" />
              {!collapsed && <span>{item.label}</span>}
            </NavLink>
          )
        })}
      </nav>
    </aside>
  )
}
